import { isNative } from './platform.js';

// Guarda os tokens do app nativo (access/refresh/session), devolvidos no
// corpo de /auth/login e /auth/refresh quando a requisição carrega o header
// X-Client-Platform: native (backend/routes/authent.py:375-378, :517-518).
// Na web isso é sempre no-op: a sessão continua 100% via cookie HttpOnly,
// sem nenhuma mudança de comportamento.
//
// Import dinâmico de @capacitor/preferences: evita que o bundle web carregue
// código do Capacitor à toa (mesmo espírito de services/platform.js).
const KEYS = { accessToken: 'cgpt.at', refreshToken: 'cgpt.rt', sessionId: 'cgpt.sid' };

let _cache = null; // cache em memória — evita um await do Preferences a cada request

async function _getPreferences() {
    const { Preferences } = await import('@capacitor/preferences');
    return Preferences;
}

export async function getTokens() {
    if (!isNative()) return null;
    if (_cache) return _cache;

    const Preferences = await _getPreferences();
    const [accessToken, refreshToken, sessionId] = await Promise.all([
        Preferences.get({ key: KEYS.accessToken }),
        Preferences.get({ key: KEYS.refreshToken }),
        Preferences.get({ key: KEYS.sessionId }),
    ]);

    // Basta o refresh token para recuperar a sessão: se só o access token
    // estiver ausente/vazio, ainda dá para renovar em vez de exigir novo login.
    if (!accessToken.value && !refreshToken.value) return null;

    _cache = {
        accessToken: accessToken.value,
        refreshToken: refreshToken.value,
        sessionId: sessionId.value,
    };
    return _cache;
}

export async function setTokens({ accessToken, refreshToken, sessionId }) {
    if (!isNative()) return;

    _cache = {
        accessToken: accessToken ?? _cache?.accessToken ?? null,
        refreshToken: refreshToken ?? _cache?.refreshToken ?? null,
        sessionId: sessionId ?? _cache?.sessionId ?? null,
    };

    const Preferences = await _getPreferences();
    const writes = [];
    if (accessToken !== undefined) writes.push(Preferences.set({ key: KEYS.accessToken, value: accessToken ?? '' }));
    if (refreshToken !== undefined) writes.push(Preferences.set({ key: KEYS.refreshToken, value: refreshToken ?? '' }));
    if (sessionId !== undefined) writes.push(Preferences.set({ key: KEYS.sessionId, value: String(sessionId ?? '') }));
    await Promise.all(writes);
}

export async function clearTokens() {
    if (!isNative()) return;
    _cache = null;

    const Preferences = await _getPreferences();
    await Promise.all([
        Preferences.remove({ key: KEYS.accessToken }),
        Preferences.remove({ key: KEYS.refreshToken }),
        Preferences.remove({ key: KEYS.sessionId }),
    ]);
}
